module.exports = __webpack_public_path__ + "media/images/athletes/1622-f60b93da3c7ff9b3bcf7755d3b0c00b0.png";